import React from 'react';
import styled from 'styled-components';
import HeaderTwo from '../parts/HeaderTwo';
import LinkText from "../parts/LinkText";

type NoticeProps = {
  backgroundColor?: string;
}

const NoticeStyle = styled.div<{ $backgroundColor?: string }>`
  background: ${props => props.$backgroundColor || 'white'};
  padding: 60px 30px 60px 30px;

  @media (max-width: 768px) {
    padding: 30px 10px 30px 10px;
  }
`;

const NoticeLinkTextStyle = styled(LinkText)`
  display: block;
  border-bottom: 1px solid #383432;
  margin-bottom: 20px;
`;

const DateStyle = styled.span`
  font-size: 14px;
  margin-right: 10px;
`;

const Notice: React.FC<NoticeProps> = ({ backgroundColor }) => {
  return (
    <NoticeStyle $backgroundColor={backgroundColor}>
      <HeaderTwo mb='20px'>お知らせ</HeaderTwo>
      <DateStyle>2025/03/04</DateStyle>
      <NoticeLinkTextStyle href="https://www.notion.so/alwaysblue/1ab9b67a63a280839275d2b85fc8b988?pvs=4">
        <b>キャンペーン終了のお知らせ</b>
      </NoticeLinkTextStyle>
      <DateStyle>2024/11/11</DateStyle>
      <NoticeLinkTextStyle href="https://alwaysblue.notion.site/13a9b67a63a2807da12ecdcddf4b5b54?pvs=4">
        <b>新ランキング制度スタート＆豪華キャンペーン実施！</b>
      </NoticeLinkTextStyle>
      <DateStyle>2024/09/24</DateStyle>
      <NoticeLinkTextStyle href="https://alwaysblue.notion.site/Cafect-1099b67a63a280c78298f208a6940963?pvs=4">
        <b>Cafect認定バッチ制度のご案内</b>
      </NoticeLinkTextStyle>
      <DateStyle>2024/08/01</DateStyle>
      <NoticeLinkTextStyle href="https://www.notion.so/alwaysblue/Cafect-52b2fd426e724caba7b67fddf6f3642f?pvs=4">
        <b>あなたとカフェをつなぐ、Cafectをリリース！</b>
      </NoticeLinkTextStyle>
    </NoticeStyle>
  );
};

export default Notice;
